import { render, staticRenderFns } from "./vorgang-state-widget.vue?vue&type=template&id=235ec455"
import script from "./vorgang-state-widget.vue?vue&type=script&lang=js"
export * from "./vorgang-state-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports